import './back-to-home.css';

import EventEmitter from 'eventemitter3';
import { EventTypes } from '../../../core/event-bus';
import { Pages } from '../../../types/enums';
import { Util } from '../../../utils/util';
import { Data } from '../../../models/data';

export class BackToHome {
    private readonly _eventBus: EventEmitter;
    private readonly _data: Data;

    constructor(eventBus: EventEmitter, data: Data) {
        this._eventBus = eventBus;
        this._data = data;
    }

    public init = (): void => {
        this._eventBusListeners();
        this._setEventListeners();
    }

    private readonly _eventBusListeners = () => {
        this._eventBus.on(EventTypes.LOCATION_CHANGE, this._onLocationChange);
    }

    private readonly _onLocationChange = async (page: Pages) => {
        if (page !== Pages.TRACK_ORDER) {
            Util.hideElement("div_back_home");
            return;
        }

        Util.showElement("div_back_home");
    }

    private readonly _setEventListeners = (): void => {
        Util.setElement("onclick", "btn_back_home", this._backToHomeHandler);
    }

    private readonly _backToHomeHandler = (): void => {
        const homepageRedirectUrl = this._data.getBrandProperty("Settings").OOS.homepageRedirectUrl;
        if (Util.isAppView() || !homepageRedirectUrl) {
            this._eventBus.emit(EventTypes.LOCATION_CHANGE, Pages.LANDING);
            return;
        }

        Util.redirect(homepageRedirectUrl);
    }
}